<app-top-bar></app-top-bar>
<div class="double-opt-in-container">
  <h1 class="doi-confirm-header">{{'double-opt-in.confirm.header' | translate}}</h1>
  <p>{{'double-opt-in.confirm.sub-text' | translate}}</p>
</div>
<div class="footer-div">
  <app-footer></app-footer>
</div>
